import {Interceptor} from '@jobseeker/common-core/components/Inteceptor';
import {wrapper} from '@jobseeker/common-core/stores';
import {SeoLayout, ResponsiveLayout} from '@layouts';
import {VersionVariants} from '@jobseeker/lotus/enums';
import {getConfigByApp, utilServerSideDeviceDetection} from '@utils';
import {metaInfo} from '@configs';
import {TALENT_BRIDGE} from '@constants';
import {loadSEO} from '@helpers';

import type {GetServerSidePropsContext} from 'next/types';

import TalentBridgeLanding from '@components/TalentBridge/TalentBridgeLanding';
import {fetchTalentBridgeAllLocations} from '@components/TalentBridge/utils';

type TalentBridgeLandingPageProps = {
  seoConfig: object;
  enableCSR: boolean;
  metaData: object;
  city: string;
};

const TalentBridgeLandingPage = ({
  seoConfig,
  metaData,
  city,
}: TalentBridgeLandingPageProps) => {
  return (
    <Interceptor metaInfo={metaData}>
      <SeoLayout seoConfig={seoConfig} />
      <ResponsiveLayout
        breadcrumbElements={[]}
        variant={VersionVariants.VERSION_TWO}
      >
        <TalentBridgeLanding city={city} />
      </ResponsiveLayout>
    </Interceptor>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  store => async (context: GetServerSidePropsContext) => {
    const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
    if (isAppIimjobs) {
      return {
        notFound: true,
      };
    }

    // Extract and validate city slug from URL; if unsupported, return 404
    let normalizedCity = '';
    try {
      const rawPath = context?.resolvedUrl?.split('?')[0] || '';
      const afterBase = rawPath.split('/talent-bridge-hiring-drive/')[1] || '';
      const firstSeg = afterBase.split('/')[0] || '';
      normalizedCity = firstSeg
        .toLowerCase()
        .replace(/[^a-z-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '');
      const locations = await fetchTalentBridgeAllLocations();
      const supportedCities = Object.keys(locations || {});
      if (!normalizedCity || !supportedCities.includes(normalizedCity)) {
        return {
          notFound: true,
        };
      }
    } catch (e) {
      return {
        notFound: true,
      };
    }
    store.dispatch({
      type: 'AppContext/set_current_page',
      payload: {page: TALENT_BRIDGE},
    });

    const seoConfig = await loadSEO(TALENT_BRIDGE);
    const metaData = getConfigByApp(
      metaInfo,
      TALENT_BRIDGE,
      true,
      TALENT_BRIDGE
    );
    const {isMobile} = utilServerSideDeviceDetection(context);
    if (isMobile) {
      store.dispatch({
        type: 'AppContext/set_layout_device',
        payload: 'mobile',
      });
    }

    return {
      props: {
        seoConfig,
        metaData,
        city: normalizedCity,
      },
    };
  }
);

export default TalentBridgeLandingPage;
